import type { EnumLabelKeys } from '@/lib/enum-labels/registry';
import type { DeepLinkReportId } from '@/components/reports/shared/deep-link-report-type';
import type { NativeReportId } from '@/components/reports/shared/native-report-type';
import type { ReportType } from '@/types/generated/endpoints/reports';

export const REPORT_TYPE_LABEL_KEYS: EnumLabelKeys<ReportType> = {
  org_performance: 'report_type.org_performance',
  strategy: 'report_type.strategy',
  platform_comparison: 'report_type.platform_comparison',
  budget_utilization: 'report_type.budget_utilization',
  top_performers: 'report_type.top_performers',
  recommendations_digest: 'report_type.recommendations_digest',
  ai_performance: 'report_type.ai_performance',
  attribution: 'report_type.attribution',
  custom: 'report_type.custom',
};

export const NATIVE_REPORT_LABEL_KEYS: EnumLabelKeys<NativeReportId> = {
  google_account: 'native_report.google_account',
  google_campaigns: 'native_report.google_campaigns',
  google_search_terms: 'native_report.google_search_terms',
  google_quality_score: 'native_report.google_quality_score',
  google_ads: 'native_report.google_ads',
  google_product_partitions: 'native_report.google_product_partitions',
  google_bidding_strategies: 'native_report.google_bidding_strategies',
  google_device: 'native_report.google_device',
  google_geo: 'native_report.google_geo',
  google_daypart: 'native_report.google_daypart',
  google_weekday: 'native_report.google_weekday',
  google_age: 'native_report.google_age',
  google_gender: 'native_report.google_gender',
  meta_creative: 'native_report.meta_creative',
  meta_placement: 'native_report.meta_placement',
  meta_device: 'native_report.meta_device',
  meta_age: 'native_report.meta_age',
  meta_gender: 'native_report.meta_gender',
  meta_daypart: 'native_report.meta_daypart',
};

export const DEEP_LINK_REPORT_LABEL_KEYS: EnumLabelKeys<DeepLinkReportId> = {
  google_auction_insights: 'deep_link_report.google_auction_insights',
  meta_audience_overlap: 'deep_link_report.meta_audience_overlap',
};
